import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    errorContainer: {
        padding: theme.spacing(4),
        margin: theme.spacing(2),
        backgroundColor: '#fff5f5',
        border: '2px solid #fed7d7',
        borderRadius: theme.spacing(1),
        maxWidth: '100%',
        overflow: 'auto'
    },
    errorTitle: {
        color: '#c53030',
        marginBottom: theme.spacing(2),
        fontWeight: 'bold'
    },
    errorMessage: {
        color: '#2d3748',
        marginBottom: theme.spacing(2),
        fontFamily: 'monospace',
        backgroundColor: '#f7fafc',
        padding: theme.spacing(1),
        borderRadius: theme.spacing(0.5),
        whiteSpace: 'pre-wrap'
    },
    stackTrace: {
        fontFamily: 'monospace',
        fontSize: '12px',
        backgroundColor: '#1a202c',
        color: '#e2e8f0',
        padding: theme.spacing(2),
        borderRadius: theme.spacing(0.5),
        overflow: 'auto',
        whiteSpace: 'pre-wrap',
        maxHeight: '400px'
    },
    actionButton: {
        marginTop: theme.spacing(2),
        marginRight: theme.spacing(1)
    },
    accordion: {
        marginTop: theme.spacing(2),
        '&:before': {
            display: 'none'
        }
    },
    componentStack: {
        fontFamily: 'monospace',
        fontSize: '12px',
        backgroundColor: '#f7fafc',
        padding: theme.spacing(1),
        borderRadius: theme.spacing(0.5),
        whiteSpace: 'pre-wrap',
        maxHeight: '300px',
        overflow: 'auto'
    }
})) 